import type { ReactNode } from 'react';
import { Group, Stack, Text, Button as MantineButton } from '@mantine/core';
import { actionIcons } from '../icons/actionIcons';
import { iconSizes, iconStroke } from '../icons/iconTypes';
import { Button } from './Button';

export function FilterBar({
  search,
  filters,
  actions,
  appliedSummary,
  onClear,
  clearLabel = 'Сбросить фильтры',
}: {
  search?: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
  appliedSummary?: ReactNode;
  onClear?: () => void;
  clearLabel?: string;
}) {
  const ClearIcon = actionIcons.close;
  return (
    <Stack gap="xs" data-testid="filter-bar">
      <Group gap="sm" wrap="wrap" align="flex-end" justify="space-between">
        <Group gap="sm" wrap="wrap" align="flex-end" style={{ flex: '1 1 auto', minWidth: 0 }}>
          {search}
          {filters}
          {onClear ? (
            <MantineButton
              variant="subtle"
              color="gray"
              size="sm"
              leftSection={<ClearIcon size={iconSizes.inline} stroke={iconStroke} />}
              onClick={onClear}
            >
              {clearLabel}
            </MantineButton>
          ) : null}
        </Group>
        {actions ? <Group gap="sm">{actions}</Group> : null}
      </Group>
      {appliedSummary ? (
        <Text size="sm" c="dimmed" data-testid="applied-filters-summary">
          {appliedSummary}
        </Text>
      ) : null}
    </Stack>
  );
}

export function ClearFiltersAction({
  onClick,
  label = 'Сбросить',
}: {
  onClick: () => void;
  label?: string;
}) {
  return (
    <Button variant="ghost" onClick={onClick}>
      {label}
    </Button>
  );
}
